import { type ICompanyChatRoomQuery } from 'application/querySchemas/ICompanyChatRoomQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import {
    type ICompanyChatRoomListClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyChatRoomListClient';
import {
    type ICompanyChatMessagesClient,
    IGetResponse as ICompanyChatMessagesResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyChatMessagesClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanyChatRoomQuery implements ICompanyChatRoomQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyChatRoomListClient')
        public readonly companyChatRoomListClient: ICompanyChatRoomListClient,
        @inject('ICompanyChatMessagesClient')
        public readonly companyChatMessagesClient: ICompanyChatMessagesClient,
    ) {}

    public async fetchRoomList(agentName?: string): Promise<IGetResponse['data']> {
        const { data, message } = await this.companyChatRoomListClient.get({
            token: this.companyUserToken.get() || '',
            agentName,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchMessages(chatRoomId: number): Promise<ICompanyChatMessagesResponse['data']> {
        const { data, message } = await this.companyChatMessagesClient.get({
            token: this.companyUserToken.get() || '',
            chatRoomId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
